import script from "./SwiperThemedBaner.vue?vue&type=script&setup=true&lang=js"
export * from "./SwiperThemedBaner.vue?vue&type=script&setup=true&lang=js"

import "./SwiperThemedBaner.vue?vue&type=style&index=0&id=9eedc2ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9eedc2ea"]])

export default __exports__